export default {
    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, loading) => {
        state.loading = loading
    },

    SET_ROLE_CATEGORIES: (state, categories) => {
        state.roleCategories = categories
    },

    SET_CATEGORIES_LIST: (state, categories) => {
        state.categoriesList = categories
    },

    SET_REPORTS: (state, reports) => {
        state.reports = reports
    },

    SET_REPORTS_LIST: (state, reportsList) => {
        state.reportsList = reportsList
    },

    SET_REPORTS_LIST_FILTERS: (state, filters) => {
        state.reportsListFilters = filters
    },

    RESET_REPORTS_LIST_FILTERS: (state) => {
        state.reportsListFilters = {
            fromDate: null,
            toDate: null,
            sqlQuery: null
        }
    },

    CREATE_REPORT_CATEGORY: (state, category) => {
        state.roleCategories.unshift(category)
    },

    UPDATE_REPORT_CATEGORY: (state, category) => {
        const updateIndex = state.roleCategories.findIndex(it => it.id == category.id)

        if (updateIndex != -1) {
            state.roleCategories.splice(updateIndex, 1, category)
        }
    },

    REMOVE_REPORT_CATEGORY: (state, categoryId) => {
        const removeIndex = state.roleCategories.findIndex(it => it.id == categoryId)

        if (removeIndex != -1) {
            state.roleCategories.splice(removeIndex, 1)
        }
    }
}
